<template>
    <div v-if='user' class="main_wrapper">
        <div>
            <va-row :gutter="12">
                <va-column :lg="12" :md="12" :sm="12" :xs="12">
                    <div v-if="user.get('roles').includes('admin') || user.get('roles').includes('manager') || user.get('roles').includes('surveys') || user.get('roles').includes('guest')"
                        class="item_wrapper" @click="navigate('surveys')">
                        <div class="survey avatar">

                            <va-icon type="database" color="white" size="2em"></va-icon>
                        </div>
                        <div class="item_name">
                            <span>
                                {{ _('Surveys') }}
                            </span>
                        </div>
                    </div>

                    <div v-if="user.get('roles').includes('admin') || user.get('roles').includes('manager') || user.get('roles').includes('articles') || user.get('roles').includes('guest')"
                        class="item_wrapper" @click="navigate('articles')">
                        <div class="artical avatar">
                            <va-icon type="newspaper" color="white" size="2em"></va-icon>
                        </div>
                        <div class="item_name">
                            <span>
                                {{ _('Articles') }}
                            </span>
                        </div>
                    </div>

                    <div v-if="user.get('roles').includes('admin') || user.get('roles').includes('manager') || user.get('roles').includes('files') || user.get('roles').includes('guest')"
                        class="item_wrapper" @click="navigate('files')">
                        <div class="file avatar">
                            <va-icon type="folder-open" color="white" size="2em"></va-icon>
                        </div>
                        <div class="item_name">
                            <span>
                                {{ _('Files') }}
                            </span>
                        </div>
                    </div>

                    <div v-if="user.get('roles').includes('admin') || user.get('roles').includes('manager') || user.get('roles').includes('maps') || user.get('roles').includes('guest')"
                        class="item_wrapper" @click="navigate('maps')">
                        <div class="group avatar">
                            <va-icon type="globe" color="white" size="2em"></va-icon>
                        </div>
                        <div class="item_name">
                            <span>
                                {{ _('Maps') }}
                            </span>
                        </div>
                    </div>
                </va-column>
            </va-row>

        </div>

    </div>
</template>

<script>
    import Parse from "@/main.js"
    import {
        mapGetters,
        mapActions
    } from "vuex";
    export default {
        data() {
            return {
                parentRoute: ''
            }
        },
        computed: {
            ...mapGetters(['user', 'getSectionGlobalCategories'])
        },
        methods: {
            async navigate(route) {
                // }
                this.$router.push("/" + route)



                // this.parentRoute = route.substring(1, route.length)
                // this.$router.push(route)
            },
        },

        mounted() {
            this.$nextTick(() => this.$store.commit("setLoading", false))
        },
    }
</script>

<style>
    .main_wrapper {
        display: flex;
        justify-content: center;
        padding-top: 120px;
        /* height: calc(100vh - 300px); */
    }

    .survey {
        background: #2295e1
    }

    .survey :hover {
        background: #2596e2
    }

    .artical {
        background: #f79e00
    }

    .file {
        background: #c4371b
    }

    .group {
        background: #f340b8
    }

    .avatar {
        padding: 60px 40px;
        border-radius: 2px;
        text-align: center;
        display: flex;
        justify-content: center;
        font-size: 2em;
    }

    .item_wrapper {
        position: relative;
        display: inline-block;
        width: 200px;
        height: 180px;
        cursor: pointer;
        margin: 20px;
        text-align: center;
    }

    .item_badge {
        position: absolute;
        right: -11px;
        top: -10px;
        width: 25px;
        height: 25px;
        display: flex !important;
        justify-content: center !important;
        align-items: center !important;
    }

    .item_name {
        color: gray;
        margin-top: 10px;
    }
</style>